import { Identity, ReportDefinition, WidgetStyle } from '@sdbn/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AppServerAPI } from '@sdbn/common';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { StructureNode } from '../../../../components/structure-node-selection/structure-node-selection.model';
import { DashboardDialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

export class IgnoreTransport {
  identity: Identity;
  ignore: boolean;
}
@Component({
    selector: 'app-list-export-transport',
    templateUrl: './list-export-transport.component.html',
    styleUrls: ['./list-export-transport.component.scss'],
    standalone: false
})
export class ListExportTransportComponent extends AbstractWidgetComponent implements OnInit {

  isLoading = false;

  availableReports = new Array<ReportDefinition>(); // ExportType.ENTIRELY, ExportType.TIME_COURSE
  selectedReport?: ReportDefinition;

  selectedStructureNode: StructureNode;

  form: FormGroup;

  transports: TransportEntry[] = new Array<TransportEntry>();

  dataSource: MatTableDataSource<TransportEntry> = new MatTableDataSource(this.transports);

  columnsToDisplay = [
    'hint',
    'carrier',
    'string1',
    'phone',
    'transportOptionMarks',
    'cargoOfRoutingPositions',
    'registrationDate',
    'processingTime',
    'waitingTime',
    // 'hasTimeSlot',
    'timeSlotPlannedStart',
    'timeSlotDelay',
    // 'wasDeleted',
    'deletionCause',
    // 'wasPaused',
    'totalTimePaused',
    'maxAllowedProcessingTime',
    // 'string2',
    // 'transportStatus',
    'processingPositionsCount',
    'messagingType',
    'smartphoneLent',
    'processingStart',
    'planningDate',
    'numberPlate',
    'trailerNumberPlate',
    'entrance',
    'leave',
    'orderReference',
    'hide'
  ];

  constructor(
    private appServerAPI: AppServerAPI,
    private dashboardDialogService: DashboardDialogService) {

    super();

    this.form = new FormGroup({
      showAllData: new FormControl(false, []),
      dateFrom: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 1), [Validators.required]),
      dateUntil: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), [Validators.required]),
      query: new FormControl('', []),
      reportDefinition: new FormControl(this.selectedReport, [])
    });

    this.form.valueChanges.subscribe(
      value => {
        this.selectedReport = value.reportDefinition;
        const eventOptions = {
          onlySelf: true,
          emitEvent: false
        };

        if (this.form.controls.showAllData.value === true) {
          this.form.controls.dateFrom.disable(eventOptions);
          this.form.controls.dateUntil.disable(eventOptions);
        } else {
          this.form.controls.dateFrom.enable(eventOptions);
          this.form.controls.dateUntil.enable(eventOptions);
        }
      }
    );
  }

  ngOnInit() {
    this.appServerAPI.execute<Array<ReportDefinition>>('/app-client/reporting/find-by-group', 'tmc-yard.transports').subscribe(reportDefinitions => {
      const definitions = new Array<ReportDefinition>();
      reportDefinitions.forEach((definition) => {
        definitions.push(new ReportDefinition(definition));
      });
      this.availableReports = definitions;
    });
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  updateList() {
    if (this.isLoading) {
      return true;
    }
    this.isLoading = true;
    const selection = new ReportSelection(this.form.value.query);

    if (this.form.controls.showAllData.value === false) {
      selection.from = this.form.value.dateFrom;
      selection.until = this.form.value.dateUntil;
      selection.stationGroupId = this.selectedStructureNode?.stationGroupId;
      selection.stationSetId = this.selectedStructureNode?.stationSetId;
    }

    this.dataSource.data = [];

    this.appServerAPI.execute<any>(`/client/control/reporting/listexport-transport`, selection)
      .subscribe(
        response => {
          this.transports.splice(0, this.transports.length);
          for (const p of response) {
            this.transports.push(new TransportEntry(p));
          }
          this.dataSource.data = this.transports;
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
        }
      );
  }

  createExcel() {
    if (this.isLoading) {
      return true;
    }
    this.isLoading = true;
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel-transport');

    // keep focus in current window
    window.focus();

    const selection = new ReportSelection(this.form.value.query);

    selection.reportDefinitionId = this.selectedReport!.id;

    if (this.form.controls.showAllData.value === false) {
      selection.from = this.form.value.dateFrom;
      selection.until = this.form.value.dateUntil;
      selection.stationGroupId = this.selectedStructureNode?.stationGroupId;
      selection.stationSetId = this.selectedStructureNode?.stationSetId;
    }


    const url = `/client/control/reporting/listexcel-transport`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }
      this.isLoading = false;
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  showTransportDetails(transport: TransportEntry) {
    this.dashboardContext.setContextValue('selected-transport', {
      id: transport.transportId,
      transportName: transport.transportName,
      transportScope: transport.transportScope
    });
    this.dashboardDialogService.openTransportDetailsDialog(this.dashboardContext);
  }

  public onSelectedStructureChanged(structureNode: StructureNode) {
    this.selectedStructureNode = structureNode;
  }

  public toggleIgnore(transport: TransportEntry) {

    const dto = new IgnoreTransport();
    dto.identity = { id: transport.transportId };
    dto.ignore = transport.ignore;

    this.appServerAPI.execute<boolean>(`/client/control/reporting/ignore-transport`, dto)
      .subscribe(
        toggleResult => {
        },
        error => {
          console.error('Error while updating Transport.');
        }
      );
  }

  public isUpdateListDisabled(): boolean {
    if (this.form.controls.showAllData.value === false) {
      return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
    }
    return false;
  }

  public isCreateDisabled(): boolean {
    if (this.form.controls.showAllData.value === false) {
      return this.form.controls.dateFrom.value == null || this.form.controls.dateUntil.value == null;
    }
    return false;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}

class ReportSelection {

  query: string;
  from: Date;
  until: Date;
  limit: number;
  stationGroupId: number;
  stationSetId: number;
  reportDefinitionId: string;

  constructor(query: string, from?: Date, until?: Date, limit?: number, stationGroupId?: number, stationSetId?: number, reportDefinitionId?: string) {
    this.query = query;
    this.from = from;
    this.until = until;
    this.limit = 100;
    this.stationGroupId = stationGroupId;
    this.stationSetId = stationSetId;
    this.reportDefinitionId = reportDefinitionId;
  }


}

export class TransportEntry {

  constructor(entry: any) {
    this.transportId = entry.transportId;
    this.registrationDate = entry.registrationDate;
    this.hasTimeSlot = entry.hasTimeSlot;
    this.timeSlotPlannedStart = entry.timeSlotPlannedStart;
    this.timeSlotDelay = entry.timeSlotPlannedStart;
    this.processingTime = entry.processingTime;
    this.waitingTime = entry.waitingTime;
    this.wasDeleted = entry.wasDeleted;
    this.deletionCause = entry.deletionCause;
    this.wasPaused = entry.wasPaused;
    this.totalTimePaused = entry.totalTimePaused;
    this.maxAllowedProcessingTime = entry.maxAllowedProcessingTime;
    this.carrier = entry.carrier;
    this.string1 = entry.string1;
    this.string2 = entry.string2;
    this.phone = entry.phone;
    this.transportStatus = entry.transportStatus;
    this.processingPositionsCount = entry.processingPositionsCount;
    this.activeMessagingChannels = entry.activeMessagingChannels;
    this.smartphoneLent = entry.smartphoneLent;
    this.transportOptionMarks = entry.transportOptionMarks;
    this.cargoOfRoutingPositions = entry.cargoOfRoutingPositions;
    this.processingStart = entry.processingStart;
    this.planningDate = entry.planningDate;
    this.planningType = entry.planningType;
    this.preloading = entry.preloading;
    this.delayedLeave = entry.delayedLeave;
    this.numberPlate = entry.numberPlate;
    this.trailerNumberPlate = entry.trailerNumberPlate;
    this.ignore = entry.ignore;
    this.entrance = entry.entrance;
    this.leave = entry.leave;
    this.transportName = entry.transportName;
    this.transportScope = entry.transportScope;
    this.orderReference = entry.orderReference;
  }

  transportId: number;
  registrationDate: string;
  hasTimeSlot: boolean;
  timeSlotPlannedStart: string;
  timeSlotDelay: number;
  processingTime: number;
  waitingTime: number;
  wasDeleted: boolean;
  deletionCause: string;
  wasPaused: boolean;
  totalTimePaused: number;
  maxAllowedProcessingTime: number;
  carrier: string;
  string1: string;
  string2: string;
  phone: string;
  transportStatus: string;
  processingPositionsCount: number;
  activeMessagingChannels: string;
  smartphoneLent: boolean;
  transportOptionMarks: string;
  cargoOfRoutingPositions: string;
  processingStart: string;
  planningDate: string;
  planningType: string;
  preloading: string;
  delayedLeave: string;
  numberPlate: string;
  trailerNumberPlate: string;
  ignore: boolean;
  entrance: string;
  leave: string;
  transportName: string;
  transportScope: string;
  orderReference: string;
}
